<template>

    <div v-if="errMsg">  
              
        <v-dialog 
            persistent
            value="true" 
            max-width="500px"
        >
          <v-card>
            <!-- <v-card-title v-if="errMsg.type == 'warning'" class="headline">{{ $t('label.warning') }}</v-card-title> -->
            <!-- <v-card-title v-else class="headline">{{ $t('label.error') }}</v-card-title> -->
            <v-card-title class="headline">{{ errMsg.title ? errMsg.title : $t('label.error') }}</v-card-title>
            <v-card-text>
                {{ errMsg.message }}
                <ul style="list-style-type: none;">
                    <li v-for="error in errMsg.errors" :key="error.field">
                        {{ error.message }}
                    </li>
                </ul>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click.stop="closeErrorMsg">{{ $t('label.close') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

    </div>

</template>


<script>

    export default {

        computed: {

            errMsg () {

                // Check for certain known error messages and translate them where applicable
                let errors = this.$store.state.errors
                if (errors) {
                    let msg = errors.message

                    // Invalid Login
                    if (msg === 'Invalid login attempt.') {
                        errors.message = this.$i18n.t('message.invalid_login')
                    } 

                    // Insufficient Permissions
                    if (msg === 'Forbidden. Insufficient Permission.') {
                        errors.message = this.$i18n.t('message.insufficient_permission')
                    } 
                }

                return errors
            }

        },


        data () {
        return {
    
            }
        },  
        
        methods: {

            closeErrorMsg() {
                this.$store.dispatch('clearErrorMsg')
            },

        },
        
    }

</script>
